import './App.css';
import Choice from './component/BestChoice';
import Contact from './component/Contact';
import Footer from './component/Footer';
import Hero from './component/Hero';
import Navbar from './component/Navbar';
import Portfolio from './component/Portfolio';
import Services from './component/Services';

function App() {
  return (
    <div className="font-ubuntu bg-darkBlue overflow-x-hidden">
      <Navbar />
      <Hero /> 
      <Choice />
      <Services />
      <Portfolio />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
